import React, { useEffect } from 'react';
import LoginView from '../components/LoginView';
import { LoginPanelDisplay } from '@components/Login/LoginPanel';
import clayAppSumoLogo from '@app/img/login/clay-app-sumo.png';
import styles from './AppSumoLogin.module.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import EmailConfirmation from './EmailConfirmation';

export default function AppSumoLogin() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  let email = searchParams.get('email');

  if (email) {
    email = decodeURIComponent(email);
  }

  useEffect(() => {
    if (!email) {
      navigate('/login', { replace: true });
    }
  }, []);

  return (
    <LoginView>
      <LoginPanelDisplay
        headline={<div className={styles.headline}>AppSumo + Clay</div>}
        image={<img className={styles.logo} src={clayAppSumoLogo} alt="AppSumo + Clay" />}
      >
        <EmailConfirmation loginEmailRecipient={email} />
      </LoginPanelDisplay>
    </LoginView>
  );
}
